import React from 'react';

import { IOptionLabel } from './OptionLabel';
import { CheckIcon, Wrapper } from './OptionLabelElements';

const OptionLabel = (props: IOptionLabel.IProps) => {
  return (
    <Wrapper {...props}>
      {props.optionType === 'check' &&
        (props.isSelected ? (
          <CheckIcon className="icon-Check-box---Checked">
            <span className="path1" />
            <span className="path2" />
          </CheckIcon>
        ) : (
          <CheckIcon className={'icon-Checkbox-Outline'} />
        ))}
      {props.optionType === 'radio' &&
        (props.isSelected ? (
          <CheckIcon className="icon-Checkbox-and-Radio-Buttons1">
            <span className="path1" />
            <span className="path2" />
            <span className="path3" />
          </CheckIcon>
        ) : (
          <CheckIcon className={'icon-Checkbox-and-Radio-Buttons'} />
        ))}
      {props.label}
    </Wrapper>
  );
};

OptionLabel.defaultProps = {
  label: '',
  optionType: 'check',
  isSelected: false,
  onClick: () => null,
  onMouseOver: () => null,
  onMouseLeave: () => null,
  marginWrapper: '',
};

export { OptionLabel };
